import React, { Children } from 'react'
import PropTypes from 'prop-types'
import BaseBreadcrumb from './Breadcrumb'
import { Root, Separator } from './Breadcrumbs.styles'

export const Breadcrumb = BaseBreadcrumb

/**
 * The Breadcrumbs' component.
 */
const Breadcrumbs = props => {
  const { children, ...restProps } = props

  return (
    <Root {...restProps}>
      {Children.map(children, child => (
        <>
          {child}
          <Separator data-separator="true" />
        </>
      ))}
    </Root>
  )
}

Breadcrumbs.defaultProps = {
  margin: 0,
  padding: '5px 0'
}

Breadcrumbs.propTypes = {
  /**
   * Children.
   */
  children: PropTypes.node.isRequired,
  /**
   * Margin.
   */
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Padding.
   */
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default Breadcrumbs
